export default class ResponseError extends Error {
    constructor(response, ...params) {
        super(...params);

        this.response = response;
    }
}
